<div class="team-join-cta">
  <ng-container *ngIf="!membershipStatus?.isMember && membershipStatus?.hasPendingRequest">
    <span class="badge badge-warning badge-lg">Request pending approval</span>
  </ng-container>

  <ng-container *ngIf="!membershipStatus?.isMember && !membershipStatus?.hasPendingRequest">
    <button *ngIf="!isLocked"
            class="btn btn-primary"
            [disabled]="submitting || uncertain || !canJoin || !userChallengeId"
            (click)="joinOrRequest()">
      <i *ngIf="submitting" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      {{ submitting ? 'Joining…' : (requiresApproval ? 'Request to Join' : 'Join Team') }}
    </button>

    <span *ngIf="isLocked" class="text-muted">
      <i class="fa fa-lock"></i> This team is not accepting new members
    </span>
  </ng-container>
  <div *ngIf="error"><dw-message [message]="{ messageBody: error, severity: 'error', allowClose: false }"></dw-message>
    <button class="btn btn-outline-primary" (click)="refreshRequested.emit()">Refresh membership status</button></div>
</div>
